export const m7l0Solution = `use debug::print;
use debug::PrintTrait;
// do not modify code on this line or above

enum Message {
    Quit : (),
    Echo : (),
    Move : (),
    ChangeColor : (),
}

// do not modify code on this line or below

fn main() {
    Message::Quit(()).print();
    Message::Echo(()).print();
    Message::Move(()).print();
    Message::ChangeColor(()).print();
}

impl MessagePrintImpl of PrintTrait::<Message> {
    fn print(self: Message) {
        match self {
            Message::Quit(()) => ('Quit').print(),
            Message::Echo(()) => ('Echo').print(),
            Message::Move(()) => ('Move').print(),
            Message::ChangeColor(()) => ('ChangeColor').print()
        }
    }
}

#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
